import React, {useState, useEffect, useContext} from 'react';
import moment from 'moment';
import {Link} from 'react-router-dom';
import AuditContext from '../Utils/context.js';
import {useLocalStorage} from 'react-use';
import {Button, Col, Row, Card, Form  } from 'react-bootstrap';
import axios from 'axios';
import {
  CustomPaging,
  PagingState,
  SortingState,
  IntegratedSorting,
} from '@devexpress/dx-react-grid';
import {
  Grid,
  PagingPanel,
  Table,
  TableHeaderRow,
  TableColumnResizing,
} from '@devexpress/dx-react-grid-bootstrap4';
import { Loading } from 'components/Loading/loading';
import { useAlert, TYPES } from 'hooks/use-alert-hook.js';

export default function Finding() {

  const {schedule} = useContext(AuditContext);
  const [auth] = useLocalStorage('authenticated');
  const [swal, setSwal] = useAlert(null);
  const [loading, setLoading] = useState(false);
  const [countOpen, setCountOpen] = useState(0);
  const [countComplete, setCountComplete] = useState(0);
  const [countProgress, setCountProgress] = useState(0);
  const [statusAction, setStatusAction] = useState('');
  const [currentPage, setCurrentPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [pageSize, setPageSize] = useState(5);
  const [pageSizes] = useState([5, 10, 15]);
  const [sorting, setSorting] = useState([{ columnName: 'ANSWER_ACTION_ID', direction: 'asc' }]);
  const [columns] = useState([
    {name: 'ACTIONS', title: 'Action', getCellValue: row => {

      let variant = `primary`, label = `Open`;
      // switch (row.ANSWER_ACTION_STATUS & row.REJECT_EXPLAIN) {
      //   case 'OPEN' & null:
      //     variant = `danger`;
      //     label = 'OPEN' ;
      //     break;
      //   case 'COMPLETED':
      //     variant = `success`;
      //     label = row?.COMPLETED_AT ? moment(row.COMPLETED_AT, 'DD-MMM-YYYY').format('DD MMM YYYY') : `` ;
      //     break;
      //   case `IN PROGRESS`:
      //     variant = `warning`;
      //     label =  'In Progress';
      // }
      if (row.ANSWER_ACTION_STATUS == 'OPEN') {
        if (row.REJECT_EXPLAIN == null){
          variant = `primary`;
          label = 'Open' ;
        }else{
          variant = `danger`;
          label = 'Open' ;
        }
      }else if (row.ANSWER_ACTION_STATUS == 'COMPLETED'){
        variant = `success`;
        label = row?.COMPLETED_AT ? moment(row.COMPLETED_AT, 'DD-MMM-YYYY').format('DD MMM YYYY') : `` ;
      }else if (row.ANSWER_ACTION_STATUS == 'IN PROGRESS'){
        variant = `warning`;
        label =  'In Progress';
      }

      return (
        <Link to={`/admin/actions/${row.ANSWER_ACTION_ID}/edit`}>
          <Button variant={variant} size="sm">{label}</Button>
        </Link>
      );
    }},
    {name: 'ANSWER_ACTION_ID', title: 'ID', getCellValue: row => row.ANSWER_ACTION_ID},
    {name: 'CRITERIA', title: 'Criteria', getCellValue: row => row?.answer?.form?.criteria.CRITERIA_LABEL ?? `n-a`},
    {name: 'EVALUATE_DESC', title: 'Evaluation', getCellValue: row => row?.answer.EVALUATE_DESC ?? `n-a`},
    {name: 'CAUSE_DESC', title: 'Finding', getCellValue: row => row?.answer.CAUSE_DESC ?? `n-a`},
    {name: 'TYPE', title: 'Type', getCellValue: row => row?.actionType.ACTION_TYPE_NAME ?? `n-a`},
    {name: 'DUE_DATE', title: 'Due Date', getCellValue: row => row?.DUE_DATE ? moment(row.DUE_DATE, 'DD-MMM-YYYY').format('DD MMM YYYY') : ``},
    {name: 'PIC', title: `PIC`, getCellValue: row => row?.pics?.map(pic => pic?.employee?.EMP_NAME).join(`, `)},

  ]);

  const [defaultColumnWidths] = useState([
    {columnName: 'ACTIONS', width: 100 },
    { columnName: 'ANSWER_ACTION_ID', width: 60 },
    { columnName: 'CRITERIA', width: 200 },
    {columnName: 'EVALUATE_DESC', width: 180 },
    {columnName: 'CAUSE_DESC', width: 180 },
    {columnName: 'TYPE', width: 180 },
    {columnName: 'DUE_DATE', width: 180 },
    {columnName: 'PIC', width: 180 },
    {columnName: 'STATUS', width: 180 },
  ]);
  const [columnWidths, setColumnWidths] = useState(defaultColumnWidths);


  const [rows, setRows] = useState([]);

  const getRowId = row => row.ANSWER_ACTION_ID;

  const fetchAnswerActions = async () => {

    setLoading(true);
    try {

      const response = await axios.get(`${process.env.REACT_APP_API_HOST}answer-actions`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
        params: {
          SCHEDULE_ID: schedule.SCHEDULE_ID,
          expand: `answer.form.criteria,pics.employee,actionType`,
          page: currentPage + 1,
          'per-page': pageSize,
        }
      });

      setRows(response.data.items);
      setTotalCount(response.data._meta.totalCount);

    } catch (error) {
      console.log(error);
      alert(`error`);
    }

    setLoading(false);
  };

  const fetchCountingAnswerActions = async () => {

    try {

      const response = await axios.get(`${process.env.REACT_APP_API_HOST}answer-action/count-status`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
        params: {
          id: schedule.SCHEDULE_ID
        }
      });
      response.data.result.forEach(data => {
        if(data.ANSWER_ACTION_STATUS=='OPEN'){
          setCountOpen(data.JUMLAH)
        }else if(data.ANSWER_ACTION_STATUS=='IN PROGRESS'){
          setCountProgress(data.JUMLAH)
        }else if(data.ANSWER_ACTION_STATUS=='COMPLETED'){
          setCountComplete(data.JUMLAH)
        }
      })

    } catch (error) {
      console.log(error);
      alert(`error`);
    }
  };

  const fetchSearchAnswerActions = async () => {

    setLoading(true);

    try {

      const response = await axios.get(`${process.env.REACT_APP_API_HOST}answer-actions`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
        params: {
          SCHEDULE_ID: schedule.SCHEDULE_ID,
          expand: `answer.form.criteria,pics.employee,actionType`,
          ANSWER_ACTION_STATUS: statusAction
        }
      });

      setRows(response.data.items);
      setTotalCount(response.data._meta.totalCount);

    } catch (error) {
      console.log(error);
      alert(`error`);
    }

    setLoading(false);
  };

  const handleSendReminder = async () => {
    try {

      const onSuccessCallback = async () => {
        let formData = new FormData();
        formData.append('TYPE', 'REMINDER_FINDING');
        formData.append('EMAIL', JSON.parse(localStorage.getItem('authenticated')).employee.EMP_EMAIL);
        formData.append('SCHEDULE', schedule.SCHEDULE_ID);
        const response = await axios.post(`${process.env.REACT_APP_API_HOST}notification/send-email`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${JSON.parse(localStorage.getItem('authenticated')).token}`,
          }
        });
      }


      setSwal({
        type: TYPES.CONFIRM,
        payload: {
          title: `Confirmation!`,
          message: `Are you sure want to send notificaiton reminder finding?`,
          onSuccess: {
            title: `Success`,
            message: `Notification Reminder Finding has been Send`,
            callback: onSuccessCallback,
          }
        }
      });

    } catch (error) {
      setSwal({
        type: TYPES.ERROR,
        payload: {
          message: error.toString(),
        }
      });
    }
  }

  const handleSendReject = async () => {
    try {

        const onSuccessCallback = async () => {
          let formData = new FormData();
          formData.append('TYPE', 'REJECT_FINDING');
          formData.append('EMAIL', JSON.parse(localStorage.getItem('authenticated')).employee.EMP_EMAIL);
          formData.append('SCHEDULE', schedule.SCHEDULE_ID);
          const response = await axios.post(`${process.env.REACT_APP_API_HOST}notification/send-email`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${JSON.parse(localStorage.getItem('authenticated')).token}`,
            }
          });
        }

        setSwal({
          type: TYPES.CONFIRM,
          payload: {
            title: `Confirmation!`,
            message: `Are you sure want to send notificaiton reject?`,
            onSuccess: {
              title: `Success`,
              message: `Notification Reject has been Send`,
              callback: onSuccessCallback,
            }
          }
        });

    } catch (error) {
      setSwal({
        type: TYPES.ERROR,
        payload: {
          message: error.toString(),
        }
      });
    }
  }

  useEffect(fetchAnswerActions, [pageSize, currentPage]);

  useEffect(fetchCountingAnswerActions, []);

  return (
    <>
      {swal}
      <Row style={{width:"90%"}}>
        <Col md="7">
          <Card>
            <Card.Header>
              <Card.Title as="h4">Finding List</Card.Title>
            </Card.Header>
            <Card.Body>
              <Row>
                <Col sm={6} md={3}>Filter Status : </Col>
                <Col sm={6} md={4}>
                 <Form.Group as={Col}>
                    <Form.Control className="w-100" name="STATUS" as="select" onChange={e => {setStatusAction(e.target.value);}}>
                      <option>Select Status...</option>
                      <option value='OPEN'>OPEN</option>
                      <option value='IN PROGRESS'>IN PROGRESS</option>
                      <option value='COMPLETED'>COMPLETED</option>
                      <option value=''>All</option>
                    </Form.Control>
                  </Form.Group>
                </Col>
                <Col sm={6} md={3}><Button variant='primary' size="sm" onClick={fetchSearchAnswerActions}>Show</Button></Col>
                <Col sm={6} md={4}><Button variant='success' size="sm" onClick={handleSendReminder}>Notif Finding Reminder</Button></Col>
                <Col sm={6} md={4}><Button variant='danger' size="sm" onClick={handleSendReject}>Notif Finding Reject</Button></Col>
                <Col sm={6} md={4}></Col>
                <Col sm={6} md={4}>OPEN: {countOpen}</Col>
                <Col sm={6} md={4}>IN PROGRESS: {countProgress}</Col>
                <Col sm={6} md={4}>COMPLETED: {countComplete}</Col>
              </Row>
              <Grid
                rows={rows}
                columns={columns}
                getRowId={getRowId}
              >
                <PagingState
                  currentPage={currentPage}
                  onCurrentPageChange={setCurrentPage}
                  pageSize={pageSize}
                  onPageSizeChange={setPageSize}
                />
                <SortingState
                  sorting={sorting}
                  onSortingChange={setSorting}
                />
                <IntegratedSorting />
                <CustomPaging totalCount={totalCount} />
                <Table />
                <TableColumnResizing
                  columnWidths={columnWidths}
                  onColumnWidthsChange={setColumnWidths}
                />
                <TableHeaderRow showSortingControls />
                <PagingPanel
                  pageSizes={pageSizes}
                />
                {loading && <Loading />}
              </Grid>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
}